<template>
  <div id="not-found">
    <p>The requested page could not be found.</p> Go <router-link to="/">Home</router-link> ;-)
  </div>
</template>

<script>
export default {

}
</script>

<style>
#not-found {
  height: 100vh;
}

a {
  color: hsl(210, 29%, 24%);
  text-decoration: none;
}

a:hover {
  color: hsl(210, 29%, 24%);
  text-decoration: underline;
}

a:active {
  color: hsl(210, 29%, 50%);
  text-decoration: underline;
}
</style>